import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DashboardExecutivo2027 from "./pages/DashboardExecutivo2027";
import AgendaCoverage from "./pages/AgendaCoverage";
import Upload from "./pages/Upload";
import Analysis from "./pages/Analysis";
import Chat from "./pages/ChatPage";
import Settings from "./pages/Settings";
import ScheduleStrategy from "./pages/ScheduleStrategy";
import GrowthActions from "./pages/GrowthActions";
import { Component, type ReactNode } from "react";

class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error, info: any) {
    console.error("ERRBND", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="p-8 text-red-600">
          <h1 className="text-xl font-bold mb-2">Render Error</h1>
          <pre className="text-sm whitespace-pre-wrap">{this.state.error.stack || this.state.error.message}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-slate-400">Loading...</div>
      </div>
    );
  if (!user) return <Navigate to="/login" />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <Protected>
              <Layout />
            </Protected>
          }
        >
          {/* Chat is the main page */}
          <Route index element={<ErrorBoundary><Chat /></ErrorBoundary>} />
          <Route path="dashboard" element={<ErrorBoundary><Dashboard /></ErrorBoundary>} />
          <Route path="dashboard-executivo-2027" element={<ErrorBoundary><DashboardExecutivo2027 /></ErrorBoundary>} />
          <Route path="agenda-coverage" element={<Navigate to="/dashboard-executivo-2027" replace />} />
          <Route path="analysis" element={<ErrorBoundary><Analysis /></ErrorBoundary>} />
          <Route path="schedule-strategy" element={<Navigate to="/dashboard-executivo-2027" replace />} />
          <Route path="growth-actions" element={<Navigate to="/dashboard-executivo-2027" replace />} />
          <Route path="settings" element={<ErrorBoundary><Settings /></ErrorBoundary>} />
          <Route path="upload" element={<Navigate to="/settings?tab=upload" />} />
          <Route path="agents" element={<Navigate to="/settings?tab=agents" />} />
          <Route path="tokens" element={<Navigate to="/settings?tab=tokens" />} />
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </AuthProvider>
  );
}
